export default {
    curAward: null,
    giveAwards: []
}
